import { atom } from 'jotai';

export const isBarcodeOpenAtom = atom<boolean>(false);
